import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getDensityModeString } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./AgendaListDateMessage.scss');
const classNames = require('classnames/bind').bind(styles);

export interface AgendaListDateMessageProps {
    text: string;
}

export const AgendaListDateMessage = observer(function AgendaListDateMessage(
    props: AgendaListDateMessageProps
) {
    return (
        <div
            className={classNames(
                styles.dateMessage,
                isFeatureEnabled('mon-agendaList-density') && getDensityModeString()
            )}>
            {props.text}
        </div>
    );
});
